import Analytics from '@/analytics/mixpanel';
export default function AnalyticsPlugin(Vue: any) {
  Vue.prototype.$analytics = new Analytics()
}
